import React, { FC } from 'react';
import { of } from 'rxjs';

import { applicationConfig } from '../../../applicationConfig';
import { CurrentRound, Round } from '../../../common/hooks/useIdoInfo';
import { useObservable } from '../../../common/hooks/useObservable';
import { LoadingView } from '../common/LoadingView/LoadingView';
import { getCommunityWhiteListForm } from './rounds/community/CommunityWhiteListForm';
import { getSpectrumWhitelistForm } from './rounds/public/getPublicWhitelistForm';

const mapRoundCodeToFormOrError = {
  [applicationConfig.rounds[0].code]: getCommunityWhiteListForm,
  [applicationConfig.rounds[1].code]: getSpectrumWhitelistForm,
};

export interface WhitelistingStateProps {
  readonly currentRound: Round & CurrentRound;
}

export const WhitelistingState: FC<WhitelistingStateProps> = ({
  currentRound,
}) => {
  const getStream = () => {
    if (!currentRound) {
      return of(undefined);
    }
    return mapRoundCodeToFormOrError[currentRound.code]();
  };
  const [whitelistForm, whitelistFormLoading] = useObservable(getStream(), [
    currentRound?.code,
  ]);

  if (whitelistFormLoading) {
    return <LoadingView />;
  }
  return <>{whitelistForm}</>;
};
